import React from 'react';
import Layout from '../layout';
import PricingSectionOne from '../components/Pricing/PricingSectionOneNew';
import PricingSectionTwo from '../components/Pricing/PricingSectionTwoNew';
import PricingSectionThree from '../components/Pricing/PricingSectionThree';
import PricingSectionFour from '../components/Pricing/PricingSectionFour';
import PricingSectionFive from '../components/Pricing/PricingSectionFive';
import PricingSectionSix from '../components/Pricing/PricingSectionSix';
import PricingSectionSeven from '../components/Pricing/PricingSectionSeven';
import BlogPosts from '../components/Esper/HomePage/BlogPosts';
import Hero from '../assets/v2/group-168.svg';
import messages from '../i18n/en';

class Pricing extends React.PureComponent<any, any> {
  public render() {
    return (
      <Layout
        messages={messages}
        ogImage={Hero}
        title={`App and device management pricing | Esper`}
        description={`Get pricing for Esper app and device management solution to build, deploy and manage purpose-built Android devices.`}
        keywords={`Enterprise Mobile Security, BYOD, IoT, Enterprise Moblility Management, EMM, Mobile Device Management, MDM, Mobile Application Management, MAM, Android Security, Android MDM, iOS Security, Mobile Phone Security, Mobile Antivirus, Mobile Virus Scan, SaaS security, Cloud MDM, Data Loss Prevention, Android Antivirus, Cloud Security, iOS Antivirus, Free Mobile Antivirus`}
        className="first-page"
        location={this.props.location}
      >
        <PricingSectionOne messages={messages} />
        <PricingSectionTwo messages={messages} />
        <PricingSectionThree messages={messages} />
        <PricingSectionFour messages={messages} />
        <PricingSectionFive messages={messages} />
        <PricingSectionSix messages={messages} />
        <PricingSectionSeven messages={messages} />
        <BlogPosts />
      </Layout>
    );
  }
}

export default Pricing;
